import { render, staticRenderFns } from "./ModuleNav.vue?vue&type=template&id=2a1c5ee2&scoped=true&"
import script from "./ModuleNav.vue?vue&type=script&lang=js&"
export * from "./ModuleNav.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNav.vue?vue&type=style&index=0&id=2a1c5ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c5ee2",
  null
  
)

export default component.exports